import React from "react"
import styled from "styled-components"

export const SinglePost = ({ children }) => {
  return <PostWrapper>{children}</PostWrapper>
}

const PostWrapper = styled.section`
  max-width: var(--measure);
  margin: 0 auto;
  padding: 0 0 3rem;
  font-size: 1.0625rem;
  line-height: 1.7;

  h1, h2, h3, h4 {
    margin: 2rem 0 0.75rem;
    letter-spacing: -0.03em;
    text-wrap: balance;
  }

  p {
    margin: 1rem 0;
    color: var(--fg);
  }

  ul, ol {
    margin: 1rem 0 1rem 1.25rem;
  }

  a {
    color: var(--fg);
    text-decoration: underline;
    text-underline-offset: 0.18em;
  }

  blockquote {
    margin: 1.5rem 0;
    padding: 1rem 1.25rem;
    border-left: 2px solid var(--accent);
    color: var(--muted);
    font-style: italic;
  }

  pre, .gatsby-highlight {
    margin: 1.5rem 0;
  }

  img {
    width: 100%;
    height: auto;
    border-radius: 1.25rem;
    border: 1px solid var(--border);
  }

  hr {
    border: 0;
    border-top: 1px solid var(--border);
    margin: 2rem 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.95rem;
  }

  th, td {
    border: 1px solid var(--border);
    padding: 0.5rem 0.65rem;
    text-align: left;
  }
`
